var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "h5-page" },
    [
      _c("div", { staticClass: "h5-header" }, [_vm._v("扫码入库")]),
      _c("div", { staticClass: "h5-body" }, [
        _c(
          "div",
          { staticClass: "h5-card" },
          [
            _c("p", { staticClass: "scan-tip" }, [
              _vm._v(
                "\n        扫描或长按识别供应商出示的出库二维码，将识别内容复制粘贴到下方输入框提交，\n        系统将自动为您生成采购入库单（生成后请在ERP中审核完成库存联动）。\n      "
              ),
            ]),
            _c("a-textarea", {
              attrs: {
                placeholder: "请粘贴出库二维码内容（JSHOR|出库单号|防伪码）",
                rows: 4,
              },
              model: {
                value: _vm.qrContent,
                callback: function ($$v) {
                  _vm.qrContent = $$v
                },
                expression: "qrContent",
              },
            }),
            _c(
              "a-button",
              {
                staticStyle: { "margin-top": "16px" },
                attrs: {
                  type: "primary",
                  block: "",
                  size: "large",
                  loading: _vm.loading,
                  disabled: !_vm.qrContent,
                },
                on: { click: _vm.submit },
              },
              [_vm._v("\n        确认入库\n      ")]
            ),
          ],
          1
        ),
        _vm.result
          ? _c(
              "div",
              {
                staticClass: "h5-card result-card",
                class: _vm.result.already ? "warn" : "ok",
              },
              [
                _c("p", { staticClass: "result-title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.result.already ? "已处理过该出库单" : "扫码入库成功"
                    )
                  ),
                ]),
                _c("p", [
                  _vm._v("采购入库单号：" + _vm._s(_vm.result.cgrkBillNo)),
                ]),
                _vm.result.itemCount
                  ? _c("p", [_vm._v("商品数：" + _vm._s(_vm.result.itemCount))])
                  : _vm._e(),
                _vm.result.totalPrice !== undefined
                  ? _c("p", [
                      _vm._v("金额：￥" + _vm._s(_vm.result.totalPrice)),
                    ])
                  : _vm._e(),
                _c("p", { staticClass: "result-msg" }, [
                  _vm._v(_vm._s(_vm.result.message)),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _c("h5-tab-bar", { attrs: { active: "scan" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }